import $fetch from "../$fetch"
import app from "app.controller"

export default function product(id) {
  const url = this.config.API + "data/products/" + id + "?lang=" + app._currentLanguage

  return $fetch( url, {
    mode:        "cors",
    credentials: "include"
  } )
    .then( response => {
      if ( response && response.message ) console.error( response.message )
      return new this.ProductModel( response )
    } )
}



// WEBPACK FOOTER //
// ./src/sdk/product/product.js